export default "__VITE_ASSET__BnN4Rmlf__"